var iOS = function iOS() {
  var _navigator$userAgentD;

  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(((_navigator$userAgentD = navigator.userAgentData) === null || _navigator$userAgentD === void 0 ? void 0 : _navigator$userAgentD.platform) || '') || // iPad on iOS 13 detection
  navigator.userAgent.includes('Mac') && 'ontouchend' in document;
};

export default iOS;